import { Button } from "./ui/button";
import { Banknote, Plus, CreditCard, ArrowRightLeft } from "lucide-react";

const DashboardHero = () => (
  <section className="w-full max-w-3xl mx-auto pb-2 pt-6 text-left">
    <h1 className="text-2xl md:text-3xl font-semibold mb-2 text-primary">Welcome to SecureBank</h1>
    <p className="text-muted-foreground mb-4 text-base md:text-lg">Your secure, all-in-one account hub</p>
    <div className="flex gap-2 md:gap-4">
      <Button variant="secondary" className="flex gap-2 items-center"><Banknote size={18}/> Deposit</Button>
      <Button variant="outline" className="flex gap-2 items-center"><ArrowRightLeft size={18}/> Transfer</Button>
      <Button variant="outline" className="flex gap-2 items-center"><CreditCard size={18}/> Pay Bill</Button>
      <Button variant="ghost" className="flex gap-2 items-center"><Plus size={18}/> Add Account</Button>
    </div>
  </section>
);

export default DashboardHero;
